export enum FileTypeCode {
    provider = 'provider',
    imported = 'imported',
    partition = 'partition',
    realized = 'realized'
}
